/**
 * The ember — honest warmth, nothing spins. A brass ring that breathes in
 * counterpoint around whatever it wraps while thinking (the avatar breathes
 * inside; the ember breathes outside). A thin wrapper over the
 * `.avatar-ember` component class in global.css (no new CSS): when
 * `thinking`, it adds the class to a round container that holds its child;
 * otherwise it is an inert passthrough. Reduced-motion stills the ring (the
 * class's own @media rule), so callers never special-case it.
 */
import type { ReactNode } from "react";

export function Ember(props: { thinking?: boolean; className?: string; children: ReactNode }) {
  const base = "inline-flex shrink-0";
  const emberClass = props.thinking ? "avatar-ember" : "";
  const classes = [base, emberClass, props.className].filter(Boolean).join(" ");
  return <span className={classes}>{props.children}</span>;
}
